export interface DraftBlocker {
  key: string;
  label: string;
  updatedAt: number;
}

const blockers = new Map<string, DraftBlocker>();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function setDraftBlocker(key: string, dirty: boolean, label = 'Unsaved draft'): void {
  const hadBlocker = blockers.has(key);
  if (dirty) {
    blockers.set(key, { key, label, updatedAt: Date.now() });
    if (!hadBlocker) emit();
    return;
  }
  if (hadBlocker) {
    blockers.delete(key);
    emit();
  }
}

export function hasDraftBlockers(): boolean {
  return blockers.size > 0;
}

export function draftBlockerCount(): number {
  return blockers.size;
}

export function clearDraftBlocker(key: string): void {
  setDraftBlocker(key, false);
}

export function subscribeToDraftBlockers(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
